<div class="wrap uk-margin-top">

    <div *ngIf="loading === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loading === false">
        <div class="uk-form-stacked uk-margin-large uk-margin-bottom uk-grid-medium" uk-grid>
            <div class="uk-width-12-12 uk-margin-small-top" style="padding-left: 20px;">
                <div class="back-button" [routerLink]="['/ressource/vehicle/informations', id]">
                    <img src="../../../assets/icons/Back.svg" width="32px" height="32px" alt="back">
                    <span>Fiche du véhicule</span>
                </div>
            </div>
            <div class="uk-width-12-12 uk-position-relative uk-margin-top">
                <div class="main-title bold">{{ vehicle.name }} <span class="regular uk-margin-small-left">Logs techniques</span> </div>
            </div>
            <div uk-grid class="uk-width-12-12 padding-20 uk-margin-top vop-background-white remove-grid-ml-pl" style="padding-bottom: inherit;">
                <div class="title bold uk-margin-left-bottom uk-margin-medium-bottom">
                    <span>Historique des actions</span>
                </div>
                <div class="uk-form-label uk-display-block vop-blue uk-margin-small-top uk-margin-small-bottom uk-width-1-1">
                    Indisponible pour le moment, veuillez réessayer ultérieurement.
                </div>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px; padding-bottom: 0px;"></div>
            <div class="uk-width-12-12 padding-20">
                <div class="title bold uk-margin-medium-bottom">
                    <span>Historique des points GPS</span>
                </div>

                <div class="uk-display-inline-block research-form-controls">
                    <div class="uk-form-controls uk-display-inline-block">
                        <app-datepicker [(date)]="dateStart" (dateChange)="onDateChange(true, $event)"></app-datepicker>
                        <input type="time" class="search-bar regular" style="width: inherit; padding: 0px 20px 0px 20px;"
                        [(ngModel)]="hourStart" (ngModelChange)="onHourChange(true, $event)">
                    </div>
                    <div class="uk-form-controls uk-display-inline-block uk-margin-left">
                        <app-datepicker [(date)]="dateEnd" (dateChange)="onDateChange(false, $event)"></app-datepicker>
                        <input type="time" class="search-bar regular" style="width: inherit; padding: 0px 20px 0px 20px;"
                        [(ngModel)]="hourEnd" (ngModelChange)="onHourChange(false, $event)">
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<div *ngIf="loadingMap === true">
    <div uk-spinner class="uk-position-center"></div>
</div>

<div style="width:100%; height: calc(100vh - 190px);" id="map">
    <div class="highlight-distance" *ngIf="highlightedDistance.length > 0">
        <span class="regular">KM parcourus</span>
        <span class="bold uk-margin-left">{{ highlightedDistance }}</span>
    </div>
</div>